import "normalize.css";
import "amfe-flexible";
import "animate.css";

import Vue from "vue";
import "@/utils/wxFontsize";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./filters";
import ajax from "./utils/ajax";
import { setShareConfig } from "@/utils/share";

// import * as fundebug from "fundebug-javascript";
// import fundebugVue from "fundebug-vue";
// import "fundebug-revideo";

import {
  Col,
  Row,
  Toast,
  Field,
  Cell,
  CellGroup,
  Button,
  NoticeBar,
  Swipe,
  SwipeItem,
  Dialog,
  Tab,
  Tabs,
  Empty,
  List,
  Image,
  Lazyload,
  Icon,
  Grid,
  GridItem,
  Notify,
  Popup,
  Rate,
  Progress,
  Picker,
  Cascader,
  CountDown,
} from "vant";
Vue.use(Col);
Vue.use(Row);
Vue.use(Toast);
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Button);
Vue.use(NoticeBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Dialog);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Empty);
Vue.use(List);
Vue.use(Image);
Vue.use(Lazyload);
Vue.use(Icon);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Notify);
Vue.use(Popup);
Vue.use(Rate);
Vue.use(Progress);
Vue.use(Picker);
Vue.use(Cascader);
Vue.use(CountDown);

import { VueHammer } from "vue2-hammer";
VueHammer.config.swipe = {
  direction: 6,
};
Vue.use(VueHammer);

// if (process.env.NODE_ENV === "production") {
//   fundebug.apikey =
//     "a0f028355f137655c0e432b25627c03cbf0aa15e39e29c0f3550c204c98bed39";
//   fundebug.appversion = "1.2.9";
//   fundebug.releasestage = "production";
//   fundebug.setHttpBody = true;
//   fundebugVue(fundebug, Vue);
// }

Vue.prototype.$axios = ajax;

Vue.config.productionTip = false;

// 默认分享配置
setShareConfig({
  link: location.origin + process.env.BASE_URL + "api",
  title: "提升全民科学素质 夯实科技强国基础",
  desc: "2025年山西省公众科学素质网络知识竞赛",
  img: location.origin + require("@/assets/share-download-img.png"),
  isShareImage: 1,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
